import { APIMethod, fetchData } from "@client";

export async function createCompanyApiKeyQuery({userId, name, scope}) {
    const response = await fetchData("/company/apikeys", APIMethod.POST, {
        data: {user_id: userId, name, scope},
        isJSONData: true,
    });

    return response.results;
}
